module.exports = __webpack_public_path__ + "img/pr-3.74568733.png";